export default function updateOrdersStatuses(
  ordersCollection,
  updatableOrder,
  newStatus,
) {
  return ordersCollection.map((order) => ({
    ...order,
    status:
      updatableOrder?.reference === order.reference ? newStatus : order.status,
  }));
}
